import { Component } from '@angular/core';
import { PolicyScheduleUploadDto } from '../../../../service/dto-insurance';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HttpInsuranceProductService } from '../../../../service/http-insurance-product.service';

@Component({
	selector: 'app-product-schedule-view',
	standalone: false,
	templateUrl: './product-schedule-view.component.html',
	styleUrl: './product-schedule-view.component.scss'
})
export class ProductScheduleViewComponent {
	upload!: PolicyScheduleUploadDto;
	loading = true;
	processing = false;
	scheduleId!: number;
	subscription = new Subscription();

	// columns = [
	// 	{ title: '#', property: 'lineNumber' },
	// 	{ title: 'Status', property: 'status' },
	// 	{ title: 'Change Type', property: 'changeType' },
	// 	{ title: 'Name', property: 'memberName'},
	// 	{ title: 'Surname', property: 'memberSurname'},
	// 	{ title: 'Id Number', property: 'memberIdNumber'},
	// 	{ title: 'Date Of Birth', property: 'memberDateOfBirth'},
	// 	{ title: 'Gender', property: 'memberGender'},
	// 	{ title: 'Msisdn', property: 'memberMsisdn'},
	// 	{ title: 'Email Address', property: 'memberEmailAddress'},
	// ];
	constructor(
		private route: ActivatedRoute,
		private httpService: HttpInsuranceProductService) {

	}
	ngOnInit(): void {
		console.log('ViewComponent ngOnInit fired');
		this.subscription.add(
			this.route.paramMap.subscribe(paramMap => {
				console.log('paramMap changed:', paramMap.get('id'));
				this.scheduleId = +paramMap.get('id')!;
				this.fetchUpload();
			})
		);
	}
	// ngOnInit(): void {
	// 	this.subscription.add(
	// 		this.route.paramMap.subscribe(paramMap => {
	// 			this.scheduleId = +paramMap.get('id')!;
	// 			this.fetchUpload();
	// 		})
	// 	);
	// }
	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
	fetchUpload(): void {
		this.loading = true;
		this.httpService.getSchedule(this.scheduleId).subscribe({
			next: (res) => {
				this.upload = res;
				this.loading = false;
			},
			error: () => {
				this.loading = false;
			},
		});
	}

}
